<div class="hotelInfo">
    <div class="hotelTitle row">
        <div class="col-8 collection-title">
            <h2 class=""><a routerLink="{{getVillaUniqueUrl()}}">{{hotelPreviewInfo.title}}</a></h2>
        </div>
        <div class="col-4 collection-btn">
            <h4><a [ngClass]="'view-details-btn'" routerLink="{{getVillaUniqueUrl()}}">VIEW</a></h4>
        </div>
    </div>  
</div>
<div [ngClass]="hotelPreviewInfo.expiring? 'row hotelWrap offerWrap clear': 'row hotelWrap clear'">
    <div class="hotelImgMask">
        <ngb-carousel class="carousel" [interval]= "false" *ngIf="hotelPreviewInfo.pictures" (slide)="onSlide($event)">
            <ng-template ngbSlide *ngFor="let image of hotelPreviewInfo.pictures; let i = index" [id]="i">
                <a routerLink="{{getVillaUniqueUrl()}}" *ngIf="image">
                    <img *ngIf="image.preloaded" [src]="image.pictureThumbnailUrl" alt="Random first slide"> 
                </a> 
            </ng-template>
        </ngb-carousel>
    </div>
</div>